import { TrashIcon } from "lucide-react";
import Search from "src/components/input/Search";
import { updateSearchParams } from "src/utils";
import { StateList } from "src/utils/states";

interface Props {
  pageSize: number;
  email: string;
  name: string;
  state: string;
  district: string;
  searchParams: URLSearchParams;
  setSearchParams: (params: URLSearchParams) => void;
  clearAllFilters: () => void;
}

export const CandidateSearchFilter = ({pageSize, email, name, state, district, searchParams, setSearchParams, clearAllFilters}: Props) => {

  const selectedState = StateList.find((s) => s.state === state);

  return (
    <div>
      <div className="flex gap-6 my-1">
        <div className="grid grid-cols-2 gap-4">
          <div className="grid grid-cols-2 gap-6">
            <Search
              value={email}
              placeholder="Search by Email"
              onChange={(value) =>
                updateSearchParams(
                  "email",
                  value,
                  setSearchParams,
                  searchParams,
                )
              }
            />
            <Search
              value={name}
              placeholder="Search by Name"
              onChange={(value) =>
                updateSearchParams("name", value, setSearchParams, searchParams)
              }
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <select
              className="select select-bordered "
              value={state}
              onChange={(e) =>
                updateSearchParams(
                  "state",
                  e.target.value,
                  setSearchParams,
                  searchParams,
                )
              }
            >
              <option value="">
                Select State
              </option>
              {StateList.map((state) => (
                <option key={state.state} value={state.state}>
                  {state.state}
                </option>
              ))}
            </select>
            <select
              className="select select-bordered"
              value={district}
              onChange={(e) =>
                updateSearchParams(
                  "district",
                  e.target.value,
                  setSearchParams,
                  searchParams,
                )
              }
              disabled={!state}
            >
              <option value="">Select District</option>

              {selectedState?.districts.map((district) => (
                <option key={district} value={district}>
                  {district}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex items-center justify-center">
          <button onClick={clearAllFilters}>
            <TrashIcon className="size-6" />
          </button>
        </div>
      </div>
    </div>
  );
};
